exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".logo{width:15%;margin-right:40px}\n", ""]);
